// actions/test-maintenance/search.js

import { attachAuth } from '../../utils/authService';

export function searchHasErrored(bool) {
  return {
    type: 'SEARCH_TEST_M_HAS_ERRORED',
    hasErrored: bool
  };
}

export function searchIsLoading(bool) {
  return {
    type: 'SEARCH_TEST_M_IS_LOADING',
    isLoading: bool
  };
}

export function searchFetchDataSuccess(resp) {
  return {
    type: 'SEARCH_TEST_M_FETCH_DATA_SUCCESS',
    resp
  };
}

export function searchFetchData(host, body, reset) {
  return (dispatch) => {
    if (reset) {
      dispatch(searchFetchDataSuccess({}))
    }
    else {
      dispatch(searchIsLoading(true));
      dispatch(searchHasErrored(false));
      fetch(host + 'user/search', {
        method: 'post',
        body: JSON.stringify(body),
        headers: attachAuth()
      }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        dispatch(searchIsLoading(false));
        promise.json()
          .then(result => {
            dispatch(searchFetchDataSuccess(result))
          })
          .catch((e) => {
            console.log(e);
            dispatch(searchHasErrored(true))
          });
        })
        .catch((e) => {
          console.log(e);
            dispatch(searchIsLoading(false));
            dispatch(searchHasErrored(true));
        });
    }
  };
}